// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1wet7","inputDescription":"styles_inputDescription__130En"};